import { DEFAULT_SPORT } from "../domain/sport/sportTypes";
import { SportRegistry } from "./SportRegistry";
import { badmintonSportModule } from "./badminton/module";
import { pickleballSportModule } from "./pickleball/module";
import { tennisSportModule } from "./tennis/module";
import { tableTennisSportModule } from "./table-tennis/module";

/** Shared registry instance — imported by index + SportContext (no circular JSX). */
export const sportRegistry = new SportRegistry(DEFAULT_SPORT)
  .register(badmintonSportModule)
  .register(pickleballSportModule)
  .register(tennisSportModule)
  .register(tableTennisSportModule);

export function resolveSportModule(sportId) {
  return sportRegistry.resolve(sportId);
}

export function listSportModules() {
  return sportRegistry.list();
}

export function listPlayableSportModules() {
  return sportRegistry.listPlayable();
}
